import {
    BOOKING_CANCEL,
    FETCH_ORDER_RECEIPT,
    FETCH_ORDER_RECEIPT_SUCCESS,
    FETCH_ORDER_RECEIPT_FAILURE,
    RETRY_ORDER_REQUEST,
    RETRY_ORDER_FAILURE,
    RETRY_ORDER_SUCCESS,
    VOUCHER_ORDER_FAILURE,
    VOUCHER_ORDER_SUCCESS,
    ORDER_RECENT_ALTERATION,
} from 'store/actions/types';

export const orderCancel = (payload) => {
    return {
        type: BOOKING_CANCEL,
        payload: payload,
    };
};

export const fetchReceipt = (payload) => {
    return {
        type: FETCH_ORDER_RECEIPT,
        id: payload.id,
    };
};

export const fetchReceiptSuccess = (payload) => {
    return {
        type: FETCH_ORDER_RECEIPT_SUCCESS,
        payload: payload,
    };
};

export const fetchReceiptFailure = (payload) => {
    return {
        type: FETCH_ORDER_RECEIPT_FAILURE,
        payload: payload,
    };
};

export const orderRetryRequest = (payload) => {
    return {
        type: RETRY_ORDER_REQUEST,
        payload: payload,
    };
};

export const retryOrderFailure = (error) => {
    return {
        type: RETRY_ORDER_FAILURE,
        error: error,
    };
};

export const retryOrderSuccess = (id) => {
    return {
        type: RETRY_ORDER_SUCCESS,
        payload: id,
    };
};

export const voucherFailure = (error) => {
    return {
        type: VOUCHER_ORDER_FAILURE,
        error: error,
    };
};

export const voucherSuccess = (message) => {
    return {
        type: VOUCHER_ORDER_SUCCESS,
        message: message,
    };
};

export const recentAlteration = (id, status) => {
    return {
        type: ORDER_RECENT_ALTERATION,
        payload: {
            id: id,
            status: status,
        },
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/orderActions.js